<template>
    <div v-show="isShow" class="select" :class="[direction == 'column' ? 'flex-column' : '']">
        <ul class="select-label" :class="[direction == 'column' ? 'mb15 w150' : '']">
            <li class="select-label-text w150">{{ label }}</li>
        </ul>

        <div class="select-body">
            <!-- <el-radio-group v-model="mValue">
                <el-radio v-for="(item, index) in data" :key="item.id || index" :label="item.value">
                    {{ item.label }}
                </el-radio>
            </el-radio-group> -->

            <div v-for="(item, index) in data" :key="item.id || index">
                <el-popover placement="top" trigger="hover" :disabled="!item.reminder">
                    <img :src="item.reminder" alt="Reminder" class="reminder-image" />
                    <div slot="reference">
                        <el-radio v-model="mValue" :label="item.value" :class="{ mr30: index < data.length - 1 }">
                            {{ item.label }}
                        </el-radio>
                    </div>
                </el-popover>
            </div>
        </div>
    </div>
</template>

<script>
import schemaMixin from "@/mixin/schemaMixin";

export default {
    name: "SchemaRadio",

    mixins: [schemaMixin],

    provide() {
        return {
            mode: this,
        };
    },

    props: {
        value: {
            default: 0,
        },
        labelSwitch: {
            default: true,
        },
        isShow: {
            default: true,
        },
        data: {
            type: Array,
        },
    },

    data() {
        return {
            radioData: '',
        }
    },

    computed: {
        direction() {
            return this.mOptions.lineFeed || this.data.length > 3 ? "column" : "row";
        },
    },

    created() {
        this.radioData = this.$attrs.schema.value;
    },

    methods: {
        getLabel(value) {
            return this.data.find((v) => v.value == value)?.label || "暂无匹配";
        },
    },
}

</script>

<style lang="scss" scoped>
.reminder-image {
    max-width: 150px;
    /* 控制图片的大小 */
    margin-left: 10px;
}

.select {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    background: #fff;

    .select-label {
        display: flex;
        align-items: center;

        .select-label-text {
            width: 77px;
            color: #969799;
            font-size: 13px;
        }
    }

    .select-body {
        display: flex;
        flex-wrap: wrap;
    }
}

.mode-select {
    display: flex;
    justify-content: space-between;

    .mode-select-label {
        font-size: 14px;
        /*no*/
        line-height: 32px;
        /*no*/
    }

    .mode-select-body {
        display: flex;
        flex-wrap: wrap;
    }
}
</style>